import { render, staticRenderFns } from "./ArchivedDashboard.vue?vue&type=template&id=f177c2da&scoped=true&"
import script from "./ArchivedDashboard.vue?vue&type=script&lang=ts&"
export * from "./ArchivedDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ArchivedDashboard.vue?vue&type=style&index=0&id=f177c2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f177c2da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VChipGroup,VCol,VProgressCircular,VRow,VTextField})
